import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import OnTraccrButton from '../common/buttons/OnTraccrButton';
import useSearchAnalyticsFields from './useSearchAnalyticsFields';

export default function SearchAnalyticsFilterBanner({
  activeFilter,
  filteredCount,
  totalCount,
  onClear,
}) {
  const analyticsFields = useSearchAnalyticsFields();

  const description = useMemo(() => {
    if (!activeFilter) return '';
    const field = analyticsFields.find((f) => f.fieldId === activeFilter.fieldId);
    const fieldName = field?.name;
    const { value } = activeFilter;
    if (!value) return '';
    const stringValue = String(value);
    const valueLabel = stringValue === 'n/a' ? 'N/A' : `${stringValue.charAt(0).toUpperCase()}${stringValue.slice(1).toLowerCase()}`;
    return `${fieldName}: ${valueLabel}`;
  }, [activeFilter, analyticsFields]);

  const showingSubset = typeof filteredCount === 'number' && typeof totalCount === 'number';

  if (!activeFilter) return null;

  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 10, borderRadius: 8, overflow: 'hidden' }}
      message={(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            width: '100%',
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Analytics filter active</div>
            <div>
              {description}
              {showingSubset && (
                <span>
                  {' '}
                  — showing
                  {' '}
                  {filteredCount}
                  {' '}
                  of
                  {' '}
                  {totalCount}
                  {' '}
                  results
                </span>
              )}
            </div>
          </div>
          <OnTraccrButton title="Clear filter" onClick={onClear} />
        </div>
      )}
    />
  );
}

SearchAnalyticsFilterBanner.propTypes = {
  activeFilter: PropTypes.shape({
    fieldId: PropTypes.string,
    value: PropTypes.string,
  }),
  filteredCount: PropTypes.number,
  totalCount: PropTypes.number,
  onClear: PropTypes.func.isRequired,
};

SearchAnalyticsFilterBanner.defaultProps = {
  activeFilter: null,
  filteredCount: undefined,
  totalCount: undefined,
};
